import { useEffect, useState, useCallback } from "react";

export const TOURS = {
  pos: [
    { sel: "[data-testid='pos-session-bar']", title: "Barre de caisse", text: "Vérifiez ici votre boutique, le caissier et l'état de la caisse (Ouverte / Fermée)." },
    { sel: "[data-testid='pos-search-input']", title: "Trouver un produit", text: "Recherchez un article par nom, marque ou code-barres — ou scannez-le directement." },
    { sel: "[data-testid^='pos-product-']", title: "Ajouter au panier", text: "Cliquez sur un produit pour l'ajouter. Ajustez ensuite la quantité et l'emballage." },
    { sel: "[data-testid='pos-customer-search']", title: "Associer un client", text: "Facultatif pour une vente comptant, obligatoire pour une vente à crédit." },
    { sel: null, title: "Encaisser", text: "Vérifiez le total, choisissez Comptant / Partiel / Crédit et le mode de paiement, puis validez. Vous pourrez imprimer ou partager le reçu par WhatsApp." },
  ],
  cash: [
    { sel: "[data-testid='open-cash-btn']", title: "Ouvrir la caisse", text: "Commencez la journée en ouvrant une caisse : choisissez l'emplacement, le compte (espèces, mobile money…) et saisissez le fonds initial réellement compté." },
    { sel: "[data-testid='cash-journal-date']", title: "Journal de caisse", text: "Suivez tous les mouvements d'espèces du jour — entrées, sorties et solde. Changez la date pour revoir une journée précédente." },
    { sel: null, title: "Clôturer et compter", text: "En fin de journée, cliquez sur « Clôturer » sur la caisse ouverte. Le montant attendu est pré-rempli : comptez les espèces réelles, l'écart est calculé et tracé automatiquement." },
  ],
  quotes: [
    { sel: "[data-testid='new-quote-btn']", title: "Créer un devis", text: "Cliquez sur « Nouveau devis » pour établir une proforma : ajoutez le client, les produits, les quantités et la date de validité." },
    { sel: "[data-testid^='pdf-quote-']", title: "Aperçu & envoi", text: "Prévisualisez le devis en PDF, téléchargez-le ou partagez-le au client par WhatsApp en un clic." },
    { sel: "[data-testid^='convert-quote-']", title: "Convertir en facture", text: "Quand le client accepte, cliquez sur « Facturer » pour transformer le devis en facture et déduire le stock." },
    { sel: null, title: "Choisir le règlement", text: "Dans la fenêtre « Facturer », choisissez Comptant, Partiel ou Crédit, le mode de paiement et l'emplacement de stock, puis validez." },
  ],
};

export default function GlobalTour() {
  const [steps, setSteps] = useState(null);
  const [i, setI] = useState(0);
  const [rect, setRect] = useState(null);

  useEffect(() => {
    const id = setInterval(() => {
      if (steps) return;
      const t = localStorage.getItem("biashara.pendingTour");
      if (t && TOURS[t]) {
        const first = TOURS[t][0];
        if (!first.sel || document.querySelector(first.sel)) {
          localStorage.removeItem("biashara.pendingTour");
          setSteps(TOURS[t]); setI(0);
        }
      }
    }, 450);
    return () => clearInterval(id);
  }, [steps]);

  const step = steps ? steps[i] : null;

  const place = useCallback(() => {
    if (!step) return;
    const el = step.sel ? document.querySelector(step.sel) : null;
    setRect(el ? el.getBoundingClientRect() : null);
  }, [step]);

  useEffect(() => {
    if (!step) return;
    const el = step.sel ? document.querySelector(step.sel) : null;
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    const t = setTimeout(place, 380);
    window.addEventListener("resize", place);
    window.addEventListener("scroll", place, true);
    return () => { clearTimeout(t); window.removeEventListener("resize", place); window.removeEventListener("scroll", place, true); };
  }, [step, i, place]);

  useEffect(() => {
    if (!steps) return;
    const onKey = (e) => {
      if (e.key === "Escape") setSteps(null);
      else if (e.key === "ArrowRight") setI((x) => (x < steps.length - 1 ? x + 1 : (setSteps(null), x)));
      else if (e.key === "ArrowLeft") setI((x) => Math.max(0, x - 1));
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [steps]);

  if (!steps || !step) return null;
  const close = () => { setSteps(null); setRect(null); };
  const next = () => (i < steps.length - 1 ? setI(i + 1) : close());
  const prev = () => i > 0 && setI(i - 1);

  const pad = 8;
  const box = rect ? { top: rect.top - pad, left: rect.left - pad, width: rect.width + pad * 2, height: rect.height + pad * 2 } : null;
  const bubbleTop = box ? Math.min(box.top + box.height + 10, window.innerHeight - 210) : window.innerHeight / 2 - 90;
  const bubbleLeft = box ? Math.min(Math.max(box.left, 12), window.innerWidth - 340) : window.innerWidth / 2 - 165;

  return (
    <div className="fixed inset-0 z-[9999]" data-testid="guided-tour">
      <div className="absolute inset-0 bg-black/50" onClick={close} />
      {box && (
        <div className="absolute rounded-xl ring-4 ring-[#2563EB] ring-offset-2 ring-offset-transparent transition-all duration-300 pointer-events-none"
          style={{ top: box.top, left: box.left, width: box.width, height: box.height, boxShadow: "0 0 0 9999px rgba(0,0,0,0.5)" }} />
      )}
      <div className="absolute w-[330px] max-w-[92vw] bg-white rounded-2xl shadow-2xl p-4 border border-[#E2E8F0]"
        style={{ top: bubbleTop, left: bubbleLeft }} data-testid="guided-tour-bubble">
        <div className="flex items-center justify-between">
          <span className="text-[11px] font-bold uppercase tracking-wide text-[#2563EB]">Visite guidée · {i + 1}/{steps.length}</span>
          <button onClick={close} className="text-[#94A3B8] hover:text-[#0F172A] text-sm" data-testid="tour-skip">Passer</button>
        </div>
        <h4 className="font-head font-bold text-[#16324F] mt-1.5">{step.title}</h4>
        <p className="text-sm text-[#475569] mt-1 leading-relaxed">{step.text}</p>
        <div className="flex items-center justify-between mt-4">
          <button onClick={prev} disabled={i === 0} className="btn-outline !py-1.5 !px-3 disabled:opacity-40" data-testid="tour-prev">Précédent</button>
          <button onClick={next} className="btn-primary !py-1.5 !px-4" data-testid="tour-next">{i < steps.length - 1 ? "Suivant" : "Terminer"}</button>
        </div>
      </div>
    </div>
  );
}
